import React from 'react'
import Head from 'next/head'
import logger from '../../services/logger'
import { getPressArticleBySlug } from '../../services/strapi'
import { toJsonLdString } from '../../helpers/faq'
import PressArticle from '../../components/press/PressArticle'
import articleSchema from '../../schemas/article.json'

export async function getServerSideProps({ params, res }) {
  logger.log('PressArticle.getServerSideProps: fetching press article', { slug: params.slug })
  const article = await getPressArticleBySlug(params.slug)
  if (!article) {
    return { notFound: true }
  }
  res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=86400')
  return { props: { article: { ...article, slug: params.slug } } }
}

export default function PressArticlePage({ article }) {
  const { slug, title, summary, date, body, original_url, thumbnail, seo } = article
  const url = `https://glamsquad.com/press/${slug}`
  const metaTitle = seo?.metaTitle || title
  const metaDescription = seo?.metaDescription || summary || ''
  const ogImage = seo?.shareImage?.url || thumbnail?.url || ''

  const newsSchema = {
    ...articleSchema,
    '@type': 'NewsArticle',
    headline: metaTitle,
    description: metaDescription,
    image: ogImage || articleSchema.image,
    datePublished: date || '',
    dateModified: date || '',
    url,
    mainEntityOfPage: { '@type': 'WebPage', '@id': url },
    isBasedOn: original_url || undefined,
    wordCount: body ? body.replace(/<[^>]*>/g, '').split(/\s+/).length : 0,
  }

  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={url} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={url} />
        {ogImage && <meta property="og:image" content={ogImage} />}
        {date && <meta property="article:published_time" content={date} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        {ogImage && <meta name="twitter:image" content={ogImage} />}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: toJsonLdString(newsSchema) }} />
      </Head>
      <PressArticle article={article} />
    </>
  )
}
